import React from 'react';

import classNames from 'classnames';
import range from 'lodash/range';

import Skeleton from 'components/Skeleton';

import './style.scss';

interface TileSkeletonProps {
  className?: string;
}

export const TileSkeleton = ({ className = 'h-tile' }: TileSkeletonProps) => (
  <div className="TileSkeleton">
    <Skeleton
      data-testid="tile-skeleton"
      className={classNames('w-full', className)}
    />
  </div>
);

interface IProps {
  header?: React.ReactNode;
  numberOfSkeletonTiles: number;
  skeletonComponent?: React.ReactNode;
}

const LoadingTilesSkeleton = ({
  header,
  numberOfSkeletonTiles,
  skeletonComponent,
}: IProps) => (
  <>
    {header && <div data-testid="loading-skeleton-header">{header}</div>}
    <div className="LoadingTilesSkeleton">
      {range(0, numberOfSkeletonTiles).map((index) => (
        <div className="LoadingTilesSkeleton__tile" key={index}>
          {skeletonComponent ? (
            skeletonComponent
          ) : (
            <TileSkeleton className="h-story-tile" />
          )}
        </div>
      ))}
    </div>
  </>
);

export default LoadingTilesSkeleton;
